module.exports = __webpack_public_path__ + "static/media/outlook-icon-blue.b1acafed.svg";